import hoTro1 from "../../../assets/images/HoTro/1.jpeg";
import hoTro2 from "../../../assets/images/HoTro/2.jpeg";
import hoTro3 from "../../../assets/images/HoTro/3.jpeg";
import hoTro4 from "../../../assets/images/HoTro/4.jpeg";
import hoTro5 from "../../../assets/images/HoTro/5.jpeg";
import hoTro6 from "../../../assets/images/HoTro/6.jpeg";
import hoTro7 from "../../../assets/images/HoTro/7.jpeg";
import hoTro8 from "../../../assets/images/HoTro/8.jpeg";
import hoTro9 from "../../../assets/images/HoTro/9.jpeg";
import hoTro10 from "../../../assets/images/HoTro/10.jpeg";
const banHoTro = {
  title: "Ban",
  name: "Hỗ Trợ",
  registerMes:
    "Bấm đăng kí để có cơ hội trở thành thành viên của ban hỗ trợ nhé",
  clb: "student informatic club",
  btn: "Đăng kí CTV",
  imagesIntro: [hoTro1, hoTro2, hoTro3, hoTro4, hoTro5, hoTro6, hoTro7, hoTro8, hoTro9, hoTro10],
  mission: [
    `Quản lí và giữ gìn phòng máy của thư viện `,
    `Hỗ trợ các hoạt động của các phòng ban khác, của câu lạc bộ`,
  ],
  advantage: [
    `Trau dồi khả năng tổ chức và lên kế hoạch`,
    `Rèn luyện tinh thần học hỏi, tinh thần trách nghiệm`,
    `Có cơ hội được tiếp xúc, trải nghiệm với nhiều loại hình công việc`,
    `Được làm quen với nhiều học sinh, sinh viên, anh chị từ những chuyên ngành khác nhau`,
  ],
};

export default banHoTro;
